

// Postnummer søk

const stores = document.querySelectorAll('.store-selector-item');
const searchQuery = document.querySelector('#store-search');

const storeData = Array.from(stores).map(store => {
    const nested = store.querySelector('[data-zip-code]');
    return {
        element: store,
        zipCode: nested ? parseInt(nested.dataset.zipCode) : null
    };
});

searchQuery.addEventListener('input', (e) => {
    const search = parseInt(e.target.value);

    if (isNaN(search)) {
        e.target.value = '';
        return;
    }

    const sortedStores = storeData
        .filter(store => store.zipCode !== null)
        .sort((a, b) => Math.abs(a.zipCode - search) - Math.abs(b.zipCode - search));

    const storeContainer = document.querySelector('.store-selector-list');
    storeContainer.innerHTML = '';

    sortedStores.forEach(store => {
        storeContainer.appendChild(store.element);
    });
});
